import {IOnboardingStep} from "../onboarding-tour.service.interface";

export class OnboardingWelcomeStep implements IOnboardingStep {
    mainText = "ONBOARDING_WELCOME_STEP_MAIN_TEXT";
    secondaryText = "ONBOARDING_WELCOME_STEP_SECONDARY_TEXT";
    get targets() {
        return [];
    }
}
